"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZCheckbox = void 0;
const FontAwesome_1 = require("../../icons/FontAwesome"); //spellcheck-off
const ll_1 = require("../../languages/ll");
const styles_1 = require("@material-ui/core/styles");
const Checkbox_1 = __importDefault(require("@material-ui/core/Checkbox"));
const FormControlLabel_1 = __importDefault(require("@material-ui/core/FormControlLabel"));
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importStar(require("styled-components"));
const IconContainer = styled_components_1.default.div `
   font-size: 16px;
   color: ${p => (p.disabled ? p.theme["disabled-color"] : "rgba(0,0,0,0.6)")};
   background-color: "transparent";
   margin-top: -4px;
   margin-bottom: -3px;
   &:hover {
      background-color: "transparent";
   }
`;
const LabelComponent = styled_components_1.default.span `
   color: ${p => (p.disabled ? p.theme["disabled-color"] : "rgba(0,0,0,0.6)")};
   font-size: 12px;
   font-family: ${p => p.theme["font-family"]};
`;
exports.ZCheckbox = (props) => {
    const theme = react_1.default.useContext(styled_components_1.ThemeContext), { languageId } = react_1.default.useContext(ll_1.llContext), [state, setState] = react_1.default.useState({
        checked: props.value !== undefined
            ? props.value
            : props.defaultValue || false,
        disabled: props.disabled || false
    });
    const CheckboxStyles = styles_1.makeStyles({
        root: {
            color: `rgba(0,0,0,0.6) !important`,
            backgroundColor: "transparent !important",
            padding: 5
        }
    });
    const CheckboxStylesRoot = CheckboxStyles().root;
    const FormControlLabelStyles = styles_1.makeStyles({
        root: {
            "&:hover": {
                color: theme["hover-color"]
            },
            marginLeft: 0,
            marginRight: 10
        }
    });
    const FormControlLabelStylesRoot = FormControlLabelStyles().root;
    return (react_1.default.createElement(FormControlLabel_1.default, { className: FormControlLabelStylesRoot + " z-checkbox", control: react_1.default.createElement(Checkbox_1.default, { className: CheckboxStylesRoot, checkedIcon: react_1.default.createElement(IconContainer, { disabled: state.disabled }, FontAwesome_1.checkedIcon), icon: react_1.default.createElement(IconContainer, { disabled: state.disabled }, FontAwesome_1.uncheckedIcon), checked: props.value !== undefined
                ? props.value
                : state.checked || false, onChange: event => {
                props.onChange && props.onChange(event);
                setState({ ...state, checked: event.target.checked });
            } }), value: props.value !== undefined ? props.value : state.checked || false, label: react_1.default.createElement(LabelComponent, { disabled: state.disabled }, props.localize === false
            ? props.label
            : ll_1.ll({ key: props.label, languageId })), labelPlacement: "end", disabled: state.disabled || props.readOnly }));
};
//# sourceMappingURL=ZCheckbox.js.map